import React from "react";
import {
  booleanType,
  OriginTypes,
  PageTableType,
  trafficLightLabel,
} from "../../redux/Types";
import { Link } from "react-router-dom";
import HighlightedText from "../../util/HighlightedText";
import {
  TerritoryList,
  ColumnStickyTypes,
  ColumnTypes,
  JustificationTypes,
  optionSubTypes,
  SortTypes,
} from "../../util/table-view/TableTypes";
import moment from "moment";
// import trackFields from "../../_module/definition/trackFields";
import i18next from "i18next";
import { LinkInterestedParties } from "../../util/preview-element/LinkElement";
import store from "./../../redux/Store";
import { userDisplay } from "util/CommonFunc";
import UserDisplay from "util/UserDisplay";
import TrafficLightInfoBox from "_module/component/traffic-light-info-box/traffic-light-info-box";
import DurationDisplay from "util/DurationDisplay";

export default {
  score: {
    width: 40,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.score,
    sticky: ColumnStickyTypes.left,
    cellRenderer: (rowData) => (
      <strong
        title={
          rowData.scoreExp ? JSON.stringify(rowData.scoreExp) : "unexplained"
        }>
        {rowData.score || "--"}
      </strong>
    ),
  },
  selector: {
    width: 18,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.selector,
    sticky: ColumnStickyTypes.left,
  },
  // prodArtworkUrl: {
  //   width: 25,
  //   alignHeader: JustificationTypes.center,
  //   alignCell: JustificationTypes.center,
  //   type: ColumnTypes.thumb,
  //   tablePageType: PageTableType.SEARCH_TRACKS,
  // },

  player: {
    width: 20,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.playerAndThumb,
    sticky: ColumnStickyTypes.left,
    tablePageType: PageTableType.SEARCH_TRACKS,
    // artworkField: trackFields.prodArtworkUrl.id
    artworkField: () => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      return trackFields.prodArtworkUrl.id;
    },
  },
  libId: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.identity,
  },
  id: {
    width: 220,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.identity,
  },
  dhTrackId: {
    width: 220,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.identity,
  },
  trackTitle: {
    width: 200,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const isDiscrete =
        rowData.discretedTracks && rowData.discretedTracks.length > 0;
      const {
        mltracklibrary: { postUpdating },
      } = store.getState();
      const cTags = rowData.cTagList?.filter(
        (r) => (r.result === undefined || r.result === true) && r.indicator
      );
      const isExplicit = postUpdating || (cTags && cTags.length > 0);
      const cls =
        isDiscrete && isExplicit
          ? "DiscreteExplicitFlags"
          : isDiscrete
          ? "DiscreteFlag"
          : isExplicit
          ? "ExplicitFlag"
          : "NoFlags";
      const cTagClasses =
        cls +
        (cTags && cTags.length > 0
          ? ` cTags${cTags.length > 3 ? 3 : cTags.length}`
          : "");
      //return <span className={cTagClasses}><strong>{HighlightedText(rowData, trackFields.trackTitle.id)}</strong><span class="discreteTracks" >{rowData.discretedTracks && rowData.discretedTracks.length > 0 ? <DiscreteTracks track={rowData} /> : null } </span><PostStat track={rowData} postUpdating={postUpdating} /></span>
    },
  },
  isrc: {
    width: 90,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.identity,
  },
  iswc: {
    width: 70,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.identity,
  },
  prs: {
    width: 110,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.identity,
  },

  territories: {
    width: 110,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    type: ColumnTypes.options,
    filterOptions: TerritoryList,
  },

  adminNotes: {
    width: 110,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },

  adminTags: {
    width: 110,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },

  prodAdminTags: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },

  prodName: {
    width: 160,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      if(rowData?.is_mcf_track == true || rowData?.mlCreated == true) {
       return <strong class="tablesLink">
            <h3 class="trackAccTitle">
              {" "}
              {HighlightedText(rowData, trackFields.prodName.id)}
            </h3>
          </strong>
      } else {
      return (
        <Link
          style={{ textDecoration: "none", color: "#fff" }}
          key={rowData.prodId}
          aria-label={"Open link"}
          to={`/search/album/${rowData.prodId}`}>
          <strong class="tablesLink">
            <h3 class="trackAccTitle">
              {" "}
              {HighlightedText(rowData, trackFields.prodName.id)}
            </h3>
          </strong>
        </Link>
      );
    }
  }
  },
  catNo: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.identity,
    // cellRenderer: (rowData) => (
    //   <Link
    //     style={{ textDecoration: "none", color: "#fff" }}
    //     key={rowData.prodId}
    //     aria-label={"Open link"}
    //     to={`/search/album/${rowData.prodId}`}
    //   >
    //     <strong class="tablesLink">
    //       {HighlightedText(rowData, trackFields.catNo.id)}
    //     </strong>
    //   </Link>
    // ),
  },
  licenseStatus: {
    width: 110,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  alternativeTitle: {
    width: 120,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  musicOrigin: {
    width: 70,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.left,
    type: ColumnTypes.options,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    filterOptions: [
      {
        id: OriginTypes.commercial,
        label: i18next.t(`Commercial`),
      },
      {
        id: OriginTypes.library,
        label: i18next.t(`Library`),
      },
      {
        id: OriginTypes.commissioned,
        label: i18next.t(`Commissioned`),
      },
      { id: OriginTypes.live, label: i18next.t(`Live`) },
    ],
  },
  prodArtist: {
    width: 110,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  performer: {
    width: 100,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();

      let highlights =
        rowData.highlights && rowData.highlights[trackFields.performer.id]
          ? rowData.highlights[trackFields.performer.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="performer"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  lyricist: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();

      let highlights =
        rowData.highlights && rowData.highlights[trackFields.lyricist.id]
          ? rowData.highlights[trackFields.lyricist.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="lyricist"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  adaptor: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();

      let highlights =
        rowData.highlights && rowData.highlights[trackFields.adaptor.id]
          ? rowData.highlights[trackFields.adaptor.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="adaptor"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  administrator: {
    width: 120,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();

      let highlights =
        rowData.highlights && rowData.highlights[trackFields.administrator.id]
          ? rowData.highlights[trackFields.administrator.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="administrator"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  prodTags: {
    width: 120,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  arranger: {
    width: 100,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[trackFields.arranger.id]
          ? rowData.highlights[trackFields.arranger.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="arranger"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  composer: {
    width: 100,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[trackFields.composer.id]
          ? rowData.highlights[trackFields.composer.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="composer"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  publisher: {
    width: 110,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[trackFields.publisher.id]
          ? rowData.highlights[trackFields.publisher.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="publisher"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  originalPublisher: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights &&
        rowData.highlights[trackFields.originalPublisher.id]
          ? rowData.highlights[trackFields.originalPublisher.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="originalPublisher"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  recordLabel: {
    width: 120,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  subLyricist: {
    width: 110,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[trackFields.subLyricist.id]
          ? rowData.highlights[trackFields.subLyricist.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="subLyricist"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  subAdaptor: {
    width: 110,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[trackFields.subAdaptor.id]
          ? rowData.highlights[trackFields.subAdaptor.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="subAdaptor"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  subArranger: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[trackFields.subArranger.id]
          ? rowData.highlights[trackFields.subArranger.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="subArranger"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  subPublisher: {
    width: 120,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[trackFields.subPublisher.id]
          ? rowData.highlights[trackFields.subPublisher.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="subPublisher"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  translator: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
    cellRenderer: (rowData) => {
      const {
        orgRuntime: {
          runtime: { _trackFields: trackFields },
        },
      } = store.getState();
      let highlights =
        rowData.highlights && rowData.highlights[trackFields.translator.id]
          ? rowData.highlights[trackFields.translator.id]
          : null;
      return (
        <>
          <LinkInterestedParties
            highlights={highlights}
            rowData={rowData}
            field="translator"
            type="tracks"></LinkInterestedParties>
        </>
      );
    },
  },
  position: {
    width: 60,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.right,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  duration: {
    width: 40,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.left,
    type: ColumnTypes.number,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    cellRenderer: (rowData) => (
      <DurationDisplay seconds={rowData?.duration} />
    ),
  },
  arid: {
    width: 70,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.identity,
  },
  prodRelease: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.datetime,
  },
  dateCreated: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: false,
    type: ColumnTypes.datetime,
  },
  validFrom: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: false,
    type: ColumnTypes.datetime,
  },
  validTo: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: false,
    type: ColumnTypes.datetime,
  },
  searchableFrom: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: false,
    type: ColumnTypes.datetime,
  },
  dateLastEdited: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: false,
    type: ColumnTypes.datetime,
  },
  libName: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  prodYear: {
    width: 80,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.right,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.number,
  },
  prodNumberOfDiscs: {
    width: 110,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.right,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.number,
  },
  prodDiscNr: {
    width: 110,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.right,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  prodNotes: {
    width: 110,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.elasticString,
  },
  trackVersionTitle: {
    width: 150,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  subIndex: {
    width: 80,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.right,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  instruments: {
    width: 100,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.tag,
  },
  bpm: {
    width: 60,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.tag,
  },
  tempo: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.tag,
  },
  genres: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.tag,
  },
  moods: {
    width: 90,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.tag,
  },
  styles: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.tag,
  },
  keywords: {
    width: 100,
    alignHeader: JustificationTypes.center,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.tag,
  },
  trackNotes: {
    width: 100,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  wsId: {
    width: 180,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.identity,
  },
  wsName: {
    width: 180,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  prsWorkTunecode: {
    width: 180,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.identity,
  },
  prsWorkTitle: {
    width: 180,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  prsWorkWriters: {
    width: 180,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  prsWorkPublishers: {
    width: 180,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  restricted: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: false,
    discretable: false,
    type: ColumnTypes.boolean,
  },
  archived: {
    width: 80,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: false,
    discretable: false,
    type: ColumnTypes.boolean,
  },
  prsSearchDateTime: {
    width: 180,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.datetime,
  },
  mlCreated: {
    field: "mlCreated",
    label: "ML Created",
    width: 150,
    type: ColumnTypes.boolean,
    isSortable: true,
    isFilterable: true,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "YES",
      },
      {
        id: booleanType.FALSE,
        label: "NO",
      },
    ],
    cellRenderer: (rowData) => <span>{rowData.mlCreated ? "Yes" : "No"}</span>,
  },
  cTagMcpsOwner: {
    field: "cTagMcpsOwner",
    label: "cTagMcpsOwner",
    width: 150,
    type: ColumnTypes.options,
    isSortable: true,
    isFilterable: true,
    explicitOrForAdvSearch: true, // for AdvSearchField filters - search with OR (ML20-3404)
    filterOptions: [
      {
        id: "Yes",
        label: "YES",
      },
      {
        id: "No",
        label: "NO",
      },
      {
        id: "N/A",
        label: "N/A",
      },
    ],
    cellRenderer: (rowData) => <span>{rowData.cTagMcpsOwner}</span>,
  },
  cTagNorthAmerican: {
    field: "cTagNorthAmerican",
    label: "cTagNorthAmerican",
    width: 200,
    type: ColumnTypes.options,
    isSortable: true,
    isFilterable: true,
    explicitOrForAdvSearch: true, // for AdvSearchField filters - search with OR (ML20-3404)
    filterOptions: [
      {
        id: "Yes",
        label: "YES",
      },
      {
        id: "No",
        label: "NO",
      },
      {
        id: "N/A",
        label: "N/A",
      },
    ],
    cellRenderer: (rowData) => <span>{rowData.cTagNorthAmerican}</span>,
  },
  prodSubtitle: {
    width: 130,
    alignHeader: JustificationTypes.center,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  skyTracfficLight: {
    width: 20,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.options,
    subType: optionSubTypes.optionWithColor,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    explicitOrForAdvSearch: true,
    filterOptions: trafficLightLabel.map((item) => {
      return { id: item.id, label: item.desc };
    }),
    cellRenderer: (rowData) => {
      if (
        rowData &&
        (rowData.skyTracfficLight || rowData.skyTracfficLight == 0)
      ) {
        return (
          <>
            <TrafficLightInfoBox
              data={rowData.skyTracfficLight}></TrafficLightInfoBox>
          </>
        );
      }
    },
    defaultSort: SortTypes.desc,
  },
  prsPriorApprovalIndecator: {
    width: 20,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.options,
    subType: optionSubTypes.optionWithColor,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    explicitOrForAdvSearch: true,
    filterOptions: trafficLightLabel.map((item) => {
      return { id: item.id, label: item.desc };
    }),
    cellRenderer: (rowData) => {
      if (
        rowData &&
        (rowData.prsPriorApprovalIndecator ||
          rowData.prsPriorApprovalIndecator == 1)
      ) {
        return (
          <>
            <TrafficLightInfoBox
              PriorApproval={
                rowData.prsPriorApprovalIndecator
              }></TrafficLightInfoBox>
          </>
        );
      }
    },
  },
  streams: {
    width: 120,
    alignHeader: JustificationTypes.left,
    isSortable: false,
    isFilterable: false,
    discretable: false,
    type: ColumnTypes.countable,
  },
  downloads: {
    width: 120,
    alignHeader: JustificationTypes.left,
    isSortable: false,
    isFilterable: false,
    discretable: false,
    type: ColumnTypes.countable,
  },
  downloadCount: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  streamCount: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  rating: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  createdBy: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.users,
    explicitOrForAdvSearch: true,
    cellProp: (rowData) => ({
      filterProps: {
        ariaLabel: "Select user",
      },
      accessDataProps: {
        title: `${userDisplay(rowData?.createdBy)}`,
      },
    }),
    cellRenderer: (rowData) => <UserDisplay userId={rowData.createdBy} />,
  },
  lastEditedBy: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.users,
    explicitOrForAdvSearch: true,
    cellProp: (rowData) => ({
      filterProps: {
        ariaLabel: "Select user",
      },
      accessDataProps: {
        title: `${userDisplay(rowData?.lastEditedBy)}`,
      },
    }),
    cellRenderer: (rowData) => <UserDisplay userId={rowData.lastEditedBy} />,
  },
  org_sky_prodAlbumTypeID: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodChartPosition: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  org_sky_prodCompany: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodCountry: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodIsLibraryRecommended: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
  },
  org_sky_prodPlugger1: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodTownCityState: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodMisc1: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodMisc2: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  libNotes: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodIsPPLBlanket: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
          {
            id: booleanType.TRUE,
            label: "Yes",
          },
          {
            id: booleanType.FALSE,
            label: "Non-PPL",
          },
        ],
  },
  org_sky_prodIsMCPSBlanket: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
          {
            id: booleanType.TRUE,
            label: "Yes",
          },
          {
            id: booleanType.FALSE,
            label: "Non-MCPS",
          },
        ],
  },
  org_sky_prodLabel: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodLibrarianNotes: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_LibrarianNotes: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_NotableUses: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodNotableUses: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodPublisher: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodCatNo2: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodCatNo3: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  org_sky_prodPublisherDetails: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_prodCompanyDetails: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_MCPS: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    // filterOptions: [
    //   {
    //     id: booleanType.TRUE,
    //     label: "No",
    //   },
    //   {
    //     id: booleanType.FALSE,
    //     label: "Yes",
    //   },
    // ],
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "Yes",
      },
      {
        id: booleanType.FALSE,
        label: "Non-MCPS",
      },
    ],
  },
  org_sky_Country: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_Area: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_SingleReleaseDate: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.date,
  },
  org_sky_SingleChartPosition: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  org_sky_Decade: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_Vocal: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_ArtistWebsite: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_SocialSite: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_RecordingYear: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  org_sky_IsLibraryRecommended: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "YES",
      },
      {
        id: booleanType.FALSE,
        label: "NO",
      },
    ],
  },
  org_sky_DownloadAvailable: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "YES",
      },
      {
        id: booleanType.FALSE,
        label: "NO",
      },
    ],
  },
  org_sky_PPL: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "YES",
      },
      {
        id: booleanType.FALSE,
        label: "Non-PPL",
      },
    ],
  },
  org_sky_IsSingleRelease: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "YES",
      },
      {
        id: booleanType.FALSE,
        label: "NO",
      },
    ],
  },
  org_sky_Lyrics: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_MCPSID: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.identity,
  },
  org_sky_Misc1: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_Misc2: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_Source: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  prodId: {
    width: 110,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.identity,
  },
  numPosition: {
    width: 30,
    alignHeader: JustificationTypes.left,
    alignCell: JustificationTypes.right,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.number,
  },
  lowResAudio: {
    width: 100,
    alignHeader: JustificationTypes.left,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "Yes",
      },
      {
        id: booleanType.FALSE,
        label: "No",
      },
    ],
  },
  sourceDeleted: {
    width: 100,
    alignHeader: JustificationTypes.left,
    isFilterable: true,
    isSortable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "Yes",
      },
      {
        id: booleanType.FALSE,
        label: "No",
      },
    ],
  },
  highResAudio: {
    width: 100,
    alignHeader: JustificationTypes.left,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.boolean,
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "Yes",
      },
      {
        id: booleanType.FALSE,
        label: "No",
      },
    ],
  },
  prsPriorApprovalCode: {
    width: 100,
    alignHeader: JustificationTypes.left,
    isFilterable: true,
    isSortable: true,
    discretable: true,
    type: ColumnTypes.string,
  },
  manuallyAdded: {
    field: "manuallyAdded",
    label: "Manual Added",
    width: 150,
    type: ColumnTypes.boolean,
    isSortable: true,
    isFilterable: true,
    extentedProps: "trackmlCreated",
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "YES",
      },
      {
        id: booleanType.FALSE,
        label: "NO",
      },
    ],
  },
  converted: {
    field: "converted",
    label: "Converted",
    width: 150,
    type: ColumnTypes.boolean,
    isSortable: true,
    isFilterable: true,
    extentedProps: "trackmlCreated",
    filterOptions: [
      {
        id: booleanType.TRUE,
        label: "YES",
      },
      {
        id: booleanType.FALSE,
        label: "NO",
      },
    ],
  },
  prodLyrics: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  prodRecordLabel: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.string,
  },
  allIds: {
    width: 220,
    alignHeader: JustificationTypes.left,
    isSortable: false,
    isFilterable: true,
    type: ColumnTypes.virtualIdentity,
  },
  allNotes: {
    width: 220,
    alignHeader: JustificationTypes.left,
    isSortable: false,
    isFilterable: true,
    type: ColumnTypes.virtualString,
  },
  prodContactDetails: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.virtualString,
  },
  prodCatNoSearch: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.virtualIdentity,
  },
  contactDetails: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.virtualString,
  },
  prodDateCreated: {
    width: 150,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: false,
    type: ColumnTypes.datetime,
  },
  prodDateLastEdited: {
    width: 150,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: false,
    type: ColumnTypes.datetime,
  },
  prodCreatedBy: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.users,
    explicitOrForAdvSearch: true,
    cellProp: (rowData) => ({
      filterProps: {
        ariaLabel: "Select user",
      },
      accessDataProps: {
        title: `${userDisplay(rowData?.prodCreatedBy)}`,
      },
    }),
    cellRenderer: (rowData) => <UserDisplay userId={rowData.prodCreatedBy} />,
  },
  prodLastEditedBy: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.users,
    explicitOrForAdvSearch: true,
    cellProp: (rowData) => ({
      filterProps: {
        ariaLabel: "Select user",
      },
      accessDataProps: {
        title: `${userDisplay(rowData?.prodLastEditedBy)}`,
      },
    }),
    cellRenderer: (rowData) => (
      <UserDisplay userId={rowData.prodLastEditedBy} />
    ),
  },
  strPerformer: {
    width: 160,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  strComposer: {
    width: 160,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  strPublisher: {
    width: 160,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  strRecordLabel: {
    width: 160,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    discretable: true,
    type: ColumnTypes.elasticString,
  },
  org_sky_Rating: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.number,
  },
  org_sky_prodVocal: {
    width: 130,
    alignHeader: JustificationTypes.left,
    isSortable: true,
    isFilterable: true,
    type: ColumnTypes.elasticString,
  },
  // player: {
  //   width: 20,
  //   alignHeader: JustificationTypes.center,
  //   alignCell: JustificationTypes.center,
  //   type: ColumnTypes.player,
  //   tablePageType: PageTableType.SEARCH_TRACKS,
  // },
  menu: {
    width: 30,
    alignHeader: JustificationTypes.center,
    alignCell: JustificationTypes.center,
    type: ColumnTypes.menu,
    sticky: ColumnStickyTypes.right,
    tablePageType: PageTableType.SEARCH_TRACKS,
  },
};
